import { Col, Row } from 'react-bootstrap';
import WardList from '../components/admin/wards/WardList';
import AdminLayout from './layout/AdminLayout';
const ManageWard = () => {
  
    return (
        <AdminLayout>
            <Row>
                <Col className="container mb-4">
                    <WardList />
                </Col>
            </Row>
        </AdminLayout>
    )
}

export default ManageWard;